import React from "react"
import CommisionersDirectorsPage from "components/pages/investor/commissioners-directors"

const CaDId = (props) => <CommisionersDirectorsPage {...props} />

export default CaDId